import React, {useState} from "react";
import {Grid, Typography, Box,} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import {useNavigate} from "react-router-dom";
import './MatchDetail.css';
import {formatLabel} from "../../../utils/utils";
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import StyledPopup from "../../CommonComponents/StyledPopup/StyledPopup";
import {formatUTCDate} from "../../../utils/dateTimeutils";


interface MatchDetailProps {
    matchData: any;
    idEventForNewJob: (id: string) => void,
    setMatchData?: (updatedMatch: any) => void;
    deleteMatch: (id: string) => void;
    handleFormUpdateMatch: (id: string) => void;
    handleManageJob: (id: string, operation: string) => void;
    handleGetIdForNewJob: (idJob: string, idEvent: string) => void;
    deletingJobById: (idJob: string) => void;
}

const visibleJobStatFields = process.env.REACT_APP_SPORT === 'football' ? ['score', 'period', 'last_event_time', 'clips', 'cards', 'status', 'source'] : ['score', 'period', 'last_event_time', 'clips', 'status', 'source']
const jobStatGridSize = process.env.REACT_APP_SPORT === 'football' ? 12/7 : 2

const MatchDetail = ({
                         matchData,
                         setMatchData,
                         deleteMatch,
                         idEventForNewJob,
                         handleFormUpdateMatch,
                         handleManageJob,
                         handleGetIdForNewJob,
                         deletingJobById
                     }: MatchDetailProps) => {
    const theme = useTheme();
    const tableFiled = ['Id', 'Scheduled At', 'Status', 'Target', 'Tag', 'Update', 'Delete', ''];
    const navigate = useNavigate();
    const [dialogOpen, setDialogOpen] = useState(false);
    let [user, setUser] = useState<string | null>(null);
    const [inputValue, setInputValue] = useState("");
    const [dialogDelete, setDialogDelete] = useState(false);
    const [idEventDelete, setIdEventDelete] = useState('');
    const [idEvent, setIdEvent] = useState<string | undefined>(
        Object.entries(matchData).find(([key]) => key === 'id')?.[1] as string | undefined
    );
    const [dialogDeleteJob, setDialogDeleteJob] = useState(false);
    const [idJobDelete, setIdJobDelete] = useState<string>("");
    const [expanded, setExpanded] = useState<string | false>(() => {
        // Trova il primo elemento che non sia "highlights - onDemand"
        const firstNonOnDemand = matchData.jobMatch.find(
            (item: any) => !isExpandible(item)
        );

        return firstNonOnDemand ? firstNonOnDemand.id : false;
    });

    function isExpandible(item: any){
        return (item.target === 'highlights' && item.clip_computation === false) || (item.status === 'Starting' || item.status === 'Scheduled');
    }


    const fieldsToResize = ['clips', 'redCards', 'jobs'];

    const handleClick = (queryParams = {}) => {
        const queryString = new URLSearchParams(queryParams).toString();
        navigate(`/match/?${queryString}`);
    };

    const handleChangeAccordionJob = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
        const selectedItem = matchData.jobMatch.find((item:any) => item.id === panel); // Trova l'elemento corrispondente

        if (!selectedItem) return;

        if (selectedItem.target === 'highlights' && selectedItem.clip_computation === false) {
            // Se è "highlights - onDemand", non aggiornare lo stato di expanded
            return;
        }

        // Se non è "highlights - onDemand", aggiorna lo stato normalmente
        setExpanded(isExpanded ? panel : false);
    };


    const handleClickTableButton = (action: string, id: string) => {
        const value = action;

        if (value === "Start") {
            handleManageJob(id, "Run");
        } else if (value === "Stop") {
            handleManageJob(id, "Stop");
        }
    }


    const statusButton = (item: string): string => {
        if ((item === 'Starting') || (item === 'Running')) {
            return "Stop";
        } else if (item === 'Scheduled') {
            return "Start";
        }
        return "-";
    }

    return (

        <Box
            mb={2}
            width="100%"
            style={{
                border: `${theme.border.width.medium} ${theme.border.type.solid} ${theme.palette.lightGrey}`,
                borderRadius: theme.border.radius.md,
                backgroundColor: theme.palette.blurredBlue,
            }}
        >
            {dialogDelete &&
                <StyledPopup isOpen={dialogDelete} onClose={() => setDialogDelete(false)} title={"Confirm Deletion"}
                             fullWidth={false}>
                    <Box sx={{
                        width: '100%',
                        border: `1px solid ${theme.palette.lightGrey}`,
                        borderRadius: theme.spacing.xs,
                        padding: theme.spacing.md,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}>
                        <Box sx={{
                            width: '100%',
                            alignItems: "center",
                            justifyContent: "center",
                        }}>

                            <Typography variant="h6" gutterBottom
                                        style={{color: theme.palette.white, textAlign: 'left'}}>Are you sure you want to
                                cancel the event?</Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    width: '100%',
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Grid container spacing={2} columns={12}>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TransparentButton text={"Yes"} width={'100%'} onClick={() => {
                                            deleteMatch(idEventDelete);
                                            setDialogDelete(false)
                                        }}></TransparentButton>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TransparentButton text={"No"} width={'100%'} onClick={() => {
                                            setDialogDelete(false)
                                        }}></TransparentButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Box>
                </StyledPopup>
            }
            {dialogDeleteJob &&
                <StyledPopup isOpen={dialogDeleteJob} onClose={() => setDialogDeleteJob(false)}
                             title={"Confirm Deletion"} fullWidth={false}>
                    <Box sx={{
                        width: '100%',
                        border: `1px solid ${theme.palette.lightGrey}`,
                        borderRadius: theme.spacing.xs,
                        padding: theme.spacing.md,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}>
                        <Box sx={{
                            width: '100%',
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                            <Typography variant="h6" gutterBottom
                                        style={{color: theme.palette.white, textAlign: 'left'}}>Are you sure you want to
                                cancel the job?</Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    width: '100%',
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Grid container spacing={2} columns={12}>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TransparentButton text={"Yes"} width={'100%'} onClick={() => {
                                            deletingJobById(idJobDelete);
                                            setDialogDeleteJob(false)
                                        }}></TransparentButton>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TransparentButton text={"No"} width={'100%'} onClick={() => {
                                            setDialogDeleteJob(false)
                                        }}></TransparentButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Box>
                </StyledPopup>
            }

            <Box>
                <Grid container alignItems="center" style={{margin: 0}}>
                    {/* Prima riga */}
                    <Grid item xs={12} sx={{display: 'flex', justifyContent:'center', alignItems:'center', paddingTop: theme.spacing.md}}>
                        <Grid container item spacing={2} alignItems="space-beetween" sx={{display: 'flex', justifyContent:'center', alignItems:'center'}}>
                            {Object.entries(matchData).map(([key, value]) => {
                                    if (key === "title") {
                                        return (
                                            <Grid item xs={12} sm={6} md={3} key={key}>
                                                <Typography gutterBottom style={{
                                                    color: theme.palette.white,
                                                    textAlign: 'left',
                                                    fontSize: theme.fontSizes.pageSectionTitle
                                                }}>{value as string}</Typography>
                                            </Grid>
                                        );
                                    }
                                    if (key === "matchDate") {
                                        return (
                                            <Grid item xs={12} sm={6} md={3} key={key}>
                                                <Typography
                                                    style={{
                                                        color: theme.palette.white,
                                                        textAlign: 'left',
                                                        fontSize: theme.fontSizes.pageSectionTitle
                                                    }}>{value === "ND" ? "ND" : formatUTCDate(value as string)}</Typography>
                                            </Grid>
                                        );
                                    }
                                    if (key === 'id') {
                                        return (
                                            <>
                                                <Grid item xs={12} sm={6} md={5} onClick={(event) => {
                                                    // event.stopPropagation()
                                                }}>
                                                    <Box display="flex" style={{width: '100%'}}
                                                         justifyContent="flex-end" alignItems="center" flexWrap="wrap">
                                                        <Box sx={{
                                                            paddingLeft: theme.spacing.md,
                                                        }}>
                                                            <TransparentButton startIcon={<EditIcon/>} text=''
                                                                               onClick={(event: any) => {
                                                                                   handleFormUpdateMatch(value as string)
                                                                                   event.stopPropagation()
                                                                               }
                                                                               }></TransparentButton>
                                                        </Box>
                                                        <Box sx={{
                                                            paddingLeft: theme.spacing.md,
                                                        }}>
                                                            <TransparentButton startIcon={<DeleteIcon/>} text=''
                                                                               onClick={(event: any) => {
                                                                                   setIdEventDelete(value as string);
                                                                                   setDialogDelete(true)
                                                                                   event.stopPropagation()
                                                                               }}></TransparentButton>
                                                        </Box>
                                                        <Box sx={{
                                                            paddingLeft: theme.spacing.md,
                                                        }}>
                                                            <TransparentButton text='New Job' onClick={(event: any) => {
                                                                idEventForNewJob(value as string)
                                                                event.stopPropagation();
                                                            }}></TransparentButton>
                                                        </Box>
                                                        <Box sx={{
                                                            paddingLeft: theme.spacing.md,
                                                        }}>
                                                            <TransparentButton  text="Go to Clips"
                                                                               onClick={(event: any) => {
                                                                                   handleClick({eventId: matchData.id});
                                                                                   event.stopPropagation();
                                                                               } }/>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            </>
                                        );
                                    }
                                    if (key === "jobMatch" && Array.isArray(value)) {
                                    return (
                                        <Box width={'100%'}>
                                            <Grid container direction="row" columns={17} sx={{
                                                alignItems: 'flex-start',
                                                justifyContent: 'space-between',
                                                marginTop: theme.spacing.lg
                                            }}>
                                                <Grid item xs={0.3} sx={{
                                                    paddingBottom: theme.spacing.md
                                                }}></Grid>
                                                {tableFiled.map(value => (
                                                    <Grid item
                                                          xs={["Id"].includes(value as string) ? 4 : ["Scheduled At", "Job Based Folder"].includes(value as string) ? 3 : ["Target", ''].includes(value as string) ? 2 : 1}
                                                    >
                                                        <Typography gutterBottom style={{
                                                            color: theme.palette.white,
                                                            textAlign: 'center',
                                                            fontWeight: theme.fontWeights.title
                                                        }} sx={{
                                                            whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo
                                                            overflow: 'hidden',        // Nasconde il testo in eccesso
                                                            textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi
                                                            fontSize: {xs: theme.fontSizes.value, md: theme.fontSizes.subParagraphTitle}
                                                        }}>{value}</Typography>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                            {value.map((item: any, idx: number) => (
                                            <Accordion style={{marginTop: theme.spacing.xs}} sx={{backgroundColor: 'transparent', width: '100%',borderTop: 1, boxShadow: 0,
                                                borderColor: theme.palette.lightGrey,
                                                borderWidth: theme.border.width.medium,}} expanded={
                                                (expanded === item.id) && !isExpandible(item)
                                            }

                                                       onChange={handleChangeAccordionJob(item.id)
                                            }
                                            >
                                                <AccordionSummary sx={{
                                                    height: '40px',
                                                    paddingTop: theme.spacing.md,
                                                    marginBottom: theme.spacing.md
                                                }} >
                                                    <Grid container direction="row" sx={{alignItems: 'flex-start', justifyContent: 'space-between'}}>
                                                        <Grid item container direction='row' columns={17} key={idx}
                                                              sx={{
                                                                  alignItems: 'center',
                                                                  justifyContent: 'space-between',
                                                              }}>

                                                            <Grid item xs={0.3} display={'flex'} justifyContent={'center'}>
                                                                {!isExpandible(item) ? (expanded === item.id ?
                                                                    <ArrowDropUpIcon sx={{color: theme.palette.white}}/> :
                                                                    <ArrowDropDownIcon sx={{color: theme.palette.white}}/>) :
                                                                    ""
                                                                }
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <Typography
                                                                    variant="body1"
                                                                    gutterBottom
                                                                    style={{color: theme.palette.white, textAlign: 'center'}}
                                                                    sx={{
                                                                        whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo
                                                                        overflow: 'hidden',        // Nasconde il testo in eccesso
                                                                        textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi
                                                                    }}
                                                                >
                                                                    {item.id} {/* Mostra una proprietà come 'name' se item è un oggetto */}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                <Typography

                                                                    variant="body1"
                                                                    gutterBottom
                                                                    textAlign='center'
                                                                    style={{color: theme.palette.white, textAlign: 'center'}}
                                                                    sx={{
                                                                        whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo
                                                                        overflow: 'hidden',        // Nasconde il testo in eccesso
                                                                        textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi
                                                                    }}
                                                                >
                                                                    {formatUTCDate(item.extraction_schedule)} {/* Mostra una proprietà come 'name' se item è un oggetto */}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Typography
                                                                    variant="body1"
                                                                    gutterBottom
                                                                    textAlign='center'
                                                                    style={{color: theme.palette.white, textAlign: 'center'}}
                                                                    sx={{
                                                                        whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo
                                                                        overflow: 'hidden',        // Nasconde il testo in eccesso
                                                                        textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi
                                                                    }}
                                                                >
                                                                    {item.status} {/* Mostra una proprietà come 'name' se item è un oggetto */}
                                                                </Typography></Grid>
                                                            <Grid item xs={2}>
                                                                <Typography
                                                                    variant="body1"
                                                                    gutterBottom
                                                                    textAlign='center'
                                                                    style={{color: theme.palette.white, textAlign: 'center'}}
                                                                  /*  sx={{
                                                                        whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo
                                                                        overflow: 'hidden',        // Nasconde il testo in eccesso
                                                                        textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi
                                                                    }} */
                                                                >
                                                                    {  (item.target === 'highlights' && item.clip_computation === false) ? 'highlights - onDemand' : (item.target === 'highlights' && item.clip_computation === true)? 'clipping - highlight' : item.target } {/* Mostra una proprietà come 'name' se item è un oggetto */}
                                                                </Typography></Grid>
                                                            <Grid item xs={1}>
                                                                <Typography
                                                                    variant="body1"
                                                                    gutterBottom
                                                                    textAlign='center'
                                                                    style={{color: theme.palette.white, textAlign: 'center'}}
                                                                    sx={{
                                                                        whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo
                                                                        overflow: 'hidden',        // Nasconde il testo in eccesso
                                                                        textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi
                                                                    }}
                                                                >
                                                                    {item.tag} {/* Mostra una proprietà come 'name' se item è un oggetto */}
                                                                </Typography>
                                                            </Grid>
                                                            {/*<Grid item xs={3}>*/}
                                                            {/*    <Typography*/}
                                                            {/*        variant="body1"*/}
                                                            {/*        gutterBottom*/}
                                                            {/*        textAlign='center'*/}
                                                            {/*        style={{color: theme.palette.white, textAlign: 'center'}}*/}
                                                            {/*        sx={{*/}
                                                            {/*            whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo*/}
                                                            {/*            overflow: 'hidden',        // Nasconde il testo in eccesso*/}
                                                            {/*            textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi*/}
                                                            {/*        }}*/}
                                                            {/*    >*/}
                                                            {/*        {item.job_base_folder} /!* Mostra una proprietà come 'name' se item è un oggetto *!/*/}
                                                            {/*    </Typography></Grid>*/}
                                                            <Grid item xs={1}>
                                                                <Typography
                                                                    variant="body1"
                                                                    gutterBottom
                                                                    textAlign='center'
                                                                    style={{color: theme.palette.white, textAlign: 'center'}}
                                                                    sx={{
                                                                        whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo
                                                                        overflow: 'hidden',        // Nasconde il testo in eccesso
                                                                        textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi
                                                                        paddingLeft: theme.spacing.md
                                                                    }}
                                                                >
                                                                    {/* Mostra una proprietà come 'name' se item è un oggetto */}
                                                                    {item.status !== "Running" && item.status !== "Starting" && (item.target !== 'highlights' || item.clip_computation !== false) && (
                                                                        <TransparentButton startIcon={<EditIcon/>} text=''
                                                                                           onClick={(e) => {
                                                                                               e?.stopPropagation();
                                                                                               handleGetIdForNewJob(item.id, idEvent!)
                                                                                           }
                                                                                           }></TransparentButton>)
                                                                    }
                                                                </Typography></Grid>
                                                            <Grid item xs={1}>
                                                                <Typography
                                                                    variant="body1"
                                                                    gutterBottom
                                                                    textAlign='center'
                                                                    style={{color: theme.palette.white, textAlign: 'center'}}
                                                                    sx={{
                                                                        whiteSpace: 'nowrap',      // Impedisce il testo di andare a capo
                                                                        overflow: 'hidden',        // Nasconde il testo in eccesso
                                                                        textOverflow: 'ellipsis',  // Aggiunge i puntini sospensivi
                                                                        paddingLeft: theme.spacing.md
                                                                    }}
                                                                >
                                                                    {/* Mostra una proprietà come 'name' se item è un oggetto */}
                                                                    {item.status !== "Running" && item.status !== "Starting" && (
                                                                        <TransparentButton startIcon={<DeleteIcon/>} text=''
                                                                                           onClick={(e) => {
                                                                                               e?.stopPropagation();
                                                                                               setDialogDeleteJob(true)
                                                                                               setIdJobDelete(item.id);
                                                                                           }}></TransparentButton>
                                                                    )
                                                                    }
                                                                </Typography></Grid>
                                                            <Grid item xs={2}>
                                                                <Typography
                                                                    variant="body1"
                                                                    gutterBottom
                                                                    textAlign='center'
                                                                    margin={theme.spacing.none}
                                                                    paddingBottom={theme.spacing.sm}
                                                                >   {statusButton(item.status) !== "-" &&
                                                                    <TransparentButton width='40%' text={statusButton(item.status)}
                                                                                       onClick={(e) => {
                                                                                           e?.stopPropagation();
                                                                                           handleClickTableButton(statusButton(item.status), item.id)
                                                                                       }}></TransparentButton>
                                                                }
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{border:0 ,margin: 0, paddingTop: 0, paddingBottom: theme.spacing.md}}>
                                                    <Grid container columns={12}>
                                                        {visibleJobStatFields.map((key)=>{
                                                            value = item[key]
                                                            return (

                                                                <Grid direction="column" container item key={key}
                                                                      sx={{alignItems: 'center', height: '100%', paddingLeft: theme.spacing.sm, paddingRight: theme.spacing.sm}}
                                                                      xs={jobStatGridSize}
                                                                >
                                                                    {/* Labels */}
                                                                    {(key !== "id" && key !== 'settings' && key !== 'name' && key !== 'description' && key !== 'tag' && key !== 'away_team' && key !== 'home_team') && <Grid item xs={6} style={{width: '100%'}}>
                                                                        <Typography variant="body1"
                                                                                    style={{color: theme.palette.white, textAlign: 'center'}}>
                                                                            {formatLabel(key)}
                                                                        </Typography>
                                                                    </Grid>
                                                                    }
                                                                    {key === "ready" && (
                                                                        <Grid xs={6} item sx={{
                                                                            position: 'relative',
                                                                            display: 'flex',
                                                                            alignItems: 'flex-end',
                                                                            justifyContent: 'center',
                                                                            height: '100%',
                                                                            width: '100%'
                                                                        }}>
                                                                            <Box
                                                                                style={{
                                                                                    height: 20,
                                                                                    width: 20,
                                                                                    borderRadius: theme.border.radius.md,
                                                                                    backgroundColor: value ? theme.palette.green : theme.palette.red,
                                                                                    marginInline: '7px',
                                                                                    justifyContent: 'space-between',
                                                                                    alignItems: 'flex-end',
                                                                                    textAlign: 'center',
                                                                                }}
                                                                            />
                                                                        </Grid>)
                                                                    }
                                                                    {visibleJobStatFields.includes(key) &&
                                                                        <Grid
                                                                            item
                                                                            xs={6}
                                                                            sx={{
                                                                                justifyContent: 'center',
                                                                                display: 'flex',
                                                                                outline: `${theme.border.width.medium} ${theme.border.type.solid} ${theme.palette.lightGrey}`,
                                                                                borderRadius: theme.border.radius.md,
                                                                                textAlign: 'center',
                                                                                color: theme.palette.white,
                                                                                width: '100%',
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    justifyContent: 'flex-end',
                                                                                    color: theme.palette.white,
                                                                                    backgroundColor: "transparent"
                                                                                }}
                                                                            >
                                                                                {value === "" ? "N/D" : value as string }
                                                                            </Typography>
                                                                        </Grid>
                                                                    }
                                                                </Grid>
                                                            );

                                                        })}
                                                    </Grid>
                                                </AccordionDetails>
                                            </Accordion>
                                            ))}
                                        </Box>
                                    );
                                }
                                    return null;
                                }
                            )
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Box>


        </Box>

    );
}

export default MatchDetail;
